import { render, staticRenderFns } from "./ClassroomTable.vue?vue&type=template&id=76a5b3e7&scoped=true"
import script from "./ClassroomTable.vue?vue&type=script&lang=js"
export * from "./ClassroomTable.vue?vue&type=script&lang=js"
import style0 from "./ClassroomTable.vue?vue&type=style&index=0&id=76a5b3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a5b3e7",
  null
  
)

export default component.exports